import { ReactElement, useEffect, useState } from 'react';
import { onAuthStateChanged, User } from 'firebase/auth';
import { Navigate } from 'react-router-dom';
import { auth } from '../../database/config';

type ProtectedAdminRouteProps = {
  children: ReactElement;
};

function ProtectedAdminRoute({ children }: ProtectedAdminRouteProps) {
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const [currentUser, setCurrentUser] = useState<User | null>(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setIsCheckingAuth(false);
    });

    return () => unsubscribe();
  }, []);

  if (isCheckingAuth) {
    return <div className="admin-auth-check">Проверка авторизации...</div>;
  }

  if (!currentUser) {
    return <Navigate to="/admin" replace />;
  }

  return children;
}

export default ProtectedAdminRoute;
